import { render, staticRenderFns } from "./section-title.vue?vue&type=template&id=c1e13b46"
import script from "./section-title.vue?vue&type=script&lang=ts"
export * from "./section-title.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports